module.exports = __webpack_public_path__ + "static/img/baccarat-guide-btn.6aafd5d.jpg";